var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo YouTube",
    clipPath: "url(#clip0_181_583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M20.595 3.20024C16.991 2.95424 8.96398 2.95524 5.36498 3.20024C1.46798 3.46624 1.00898 5.82024 0.97998 12.0162C1.00898 18.2012 1.46398 20.5652 5.36498 20.8322C8.96498 21.0772 16.991 21.0782 20.595 20.8322C24.492 20.5662 24.951 18.2122 24.98 12.0162C24.951 5.83124 24.496 3.46724 20.595 3.20024ZM9.97998 16.0162V8.01624L17.98 12.0092L9.97998 16.0162Z",
    fill: "#1E1E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_181_583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.97998 0.0161133)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d01d9e2daffb59cc3ce5fce256403d1a.svg";
export { ForwardRef as ReactComponent };